import accountsReceivableFullcont from "./accountsReceivable-fullcont.html";

const dialog = require("../../../../../components/dialog/dialog");
const fullcontEntity = require("../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../components/fullcont/fullcont-handler");
const fullcontReport = require("../../../../../components/fullcont/fullcont-report");
const accountsReceivableDt = require("./accountsReceivable-dt");
const accountsReceivableMenu = require("./accountsReceivable-menu");
const { formCopy } = require("./accountsReceivable-fullcont-form");
const { form } = require("./accountsReceivable-fullcont-form");
const MtGenerator = require("./accountsReceivable-multitable-generator");
const snack = require("../../../../../components/snack/snack");
// const {accountsReceivableMT} = require('./accountsReceivable-fullcont-multitable')
const accountsReceivableMT = undefined; //no MT just add this like undefined
const accountsReceivableFetch = require("./accountsReceivable-fetch");
const accountReceivable = require("./accountsReceivable");
const style = require("../../../../../components/report/report-style");
const css = style.get();

let iframe;
let topData = null;
let tableData = null;

/****************ELEMENTS*****************/
var htmlFc = {};
var HTMLwasSelected = false;

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "accountsReceivable", //database table name****
    "accountsReceivable", //dest entity on js
    "accountsReceivable-fullcont",
    accountsReceivableFullcont,
    form,
    formCopy,
    accountsReceivableMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc
  );

  HTMLwasSelected = true;
  iframe = document.getElementById("reportIframe");
  // htmlFc.hasFiles = true
  // fullcontHandler.rightsControl(htmlFc)
} /**/

export function start(detail) {
  //console.log('accountsReceivable-dt 5>', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc);
    },
  },
  deleteEntity: {
    start: (detail) => {
      fullcontEntity.deleteEntity(detail, htmlFc);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      accountsReceivableMenu.start(detail, "htmlDt", htmlFc);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  selectOne: {
    start: (detail) => {
      fullcontEntity.selectOne(detail, htmlFc);
    },
  },
  selectOneNoCheck: {
    start: (detail) => {
      fullcontEntity.selectOneNoCheck(detail, htmlFc);
    },
  },
  update: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  callData: {
    start: (detail) => {
      callData(detail, htmlFc);
    },
  },
  callUnpaidInvoices: {
    start: (detail) => {
      callUnpaidInvoices(detail, htmlFc);
    },
  },
  click: {
    start: (detail) => {
      click(detail, htmlFc);
    },
  },
  printReportAll: {
    start: (detail) => {
      printReportAll(detail, htmlFc);
    },
  },
  printReportOne: {
    start: (detail) => {
      printReportOne(detail, htmlFc);
    },
  },
  saleFullcont2: {
    start: (detail) => {
      saleFullcont2(detail, htmlFc);
    },
  },
}; /**/

function saleFullcont2(detail, htmlFc) {
  accountReceivable.start({
    dest: detail.dest,
    elem: "saleFullcont2",
    id: "sale-fullcont2",
    act: "showFullcont",
    dbid: detail.dbid,
  });
}

//function to send
function editDialog() {
  dialog.start({
    act: "show",
    id: "saveChanges",
    entity: "accountsReceivable",
  });
}

function deleteDialog(detail) {
  dialog.start({
    act: "show",
    dest: "accountsReceivable",
    id: "deleteElem",
    entity: "accountsReceivable",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  accountsReceivableDt.start({ act: act, row: result });
}

function addOne(detail, htmlFc) {
  fullcontEntity.addOne(detail, htmlFc);
  setTimeout(() => {
    // accountsReceivableDt.start({"dest":"accountsReceivable", "elem":"dt", "act":"select", "entity":"accountsReceivable"})
  }, 100);
}

function deleteFromDialog(detail, htmlFc) {
  if (parseInt(htmlFc.fullcontHTML.getAttribute("data-DBid")) > 99) {
    fullcontEntity.deleteFromDialog(detail, htmlFc);
    setTimeout(() => {
      accountsReceivableDt.start({
        dest: "accountsReceivable",
        elem: "dt",
        act: "select",
        entity: "accountsReceivable",
      });
    }, 900);
  } else {
    snack.start({ act: "show", id: "accountidisless" });
  }
}

function callData(detail, htmlFc) {
  const fetchDetail = {
    dest: "customer",
    elem: "report",
    reportType: "accountReceivableAll",
    dbid: detail.dbid,
  };

  accountsReceivableFetch.fetchOne(fetchDetail, (data) => {
    fullcontReport.showFullcont(detail, data, {
      id: "#accountsReceivable_form_",
      fields: [
        "customer",
        "current",
        "total_due",
        "total_due_30_days",
        "total_due_31_to_60_days",
        "total_due_61_to_90_days",
        "total_due_over_90_days",
      ],
    });

    topData = data;
    tryGenerateAndInsert();
  });
}

function callUnpaidInvoices(detail, htmlFc) {
  const container = document.getElementById("multitable-report-receivable");

  const fetchDetail = {
    dest: "customer",
    elem: "report",
    reportType: "accountReceivable",
    dbid: detail.dbid,
  };

  accountsReceivableFetch.fetchUnpaidInvoices(fetchDetail, (data) => {
    fullcontReport.renderUnpaidInvoices(data, {
      container: container,
      lineRenderer: MtGenerator.unpaid_invoices_list,
      headerHtml: `
        <div class="o54">
          <div class="row">
            <div class="c20"><label class="font-caption label-report">Date</label></div>
            <div class="c20"><label class="font-caption label-report">Code</label></div>
            <div class="c20"><label class="font-caption label-report">Due Date</label></div>
            <div class="c20"><label class="font-caption label-report">Original Amount</label></div>
            <div class="c20"><label class="font-caption label-report">Due Amount</label></div>
          </div>
        </div>
      `,
      afterLineRender: (line, item) => {
        fullcontReport.autoAssignValuesByClass(line, item);
      },
    });

    tableData = data;
    tryGenerateAndInsert();
  });
}

function printHtmlInIframe(html) {
  // Si el iframe ya está en about:blank y listo, imprime de inmediato
  const doc = iframe.contentWindow.document;

  if (
    iframe.contentWindow &&
    iframe.contentWindow.location.href === "about:blank"
  ) {
    doc.open();
    doc.write(
      "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
    );
    doc.close();
    iframe.contentWindow.print();
    iframe.onload = null;
  } else {
    // Si no, espera a que cargue about:blank
    iframe.onload = function () {
      doc.open();
      doc.write(
        "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
      );
      doc.close();
      iframe.contentWindow.print();
      iframe.onload = null;
    };
  }
  iframe.src = "about:blank";
}

function printReportAll(detail, htmlFc) {
  // console.log("print >", detail);

  const dataCont = document.querySelector(".accountsReceivable-dataCont");
  printHtmlInIframe(dataCont.innerHTML);
}

function printReportOne(detail, htmlFc) {
  const dataCont = document.querySelector(".accountsReceivable-one");
  printHtmlInIframe(dataCont.innerHTML);
}

function tryGenerateAndInsert() {
  if (topData && tableData) {
    const container = document.querySelector(
      "#accountsReceivable-page-right .dataContReceivable"
    );

    if (!container) {
      console.error("Contenedor no encontrado.");
      return;
    }

    const html = generate(topData, tableData);
    container.innerHTML = ""; // opcional: limpiar antes
    container.insertAdjacentHTML("beforeend", html);

    topData = null;
    tableData = null;
  }
}

function generate(top, table) {
  var body = "";
  body += generateTop(top[0]);
  body += generateTable(table);
  body += `</div> <!-- dataCont -->`;
  body += `<div class="report-page">`;

  return body;
}

function generateTop(data) {
  var table = `<div class="dataCont accountsReceivable-one">
    <div ${css.title}>${data.company_name}</div>
    <div ${css.subtitle}>${data.customer} Account Receivable Aging Report As Of ${data.current_dateTime}</div>
  `;

  return table;
} /**/

function generateTable(agesData) {
  var totalDue = 0;

  var table = `
    <h2 ${css.f15}>${agesData[0].name + " Unpaid Invoices"}: This is a financial document that provides information about money 
      owed to a company by its customers or clients for goods or services provided on credit.</h2>
      <table ${css.table} >
        <tr>
          <th ${css.th}>Date</th>
          <th ${css.th}>code</th>   
          <th ${css.th}>Due Date</th>        
          <th ${css.th}>Original Amount</th>
          <th ${css.th}>Due Amount</th>      
        </tr> 
  `;
  //SI EL REPORTE RETIRNO NADA
  if (agesData[0].ageDueAmount == null) {
    table += `
      <tr>
        <td ${css.td} colspan="5"  ><div align="center"><h3>No Due Invoices Were Found.</h3></div></td>
      </tr> 
    `;

    table += `</table>`;

    return table;
  }

  for (let i = 0; i < agesData.length; i++) {
    table += `
      <tr>
        <td ${css.td} colspan="5" bgcolor="lightgray" >
          <div align="center">
            <div style="font-weight: bold;">${agesData[i].overdue_age + " " + agesData[i].ageDueAmount}</div>
          </div>
        </td>
      </tr> 
    `;

    totalDue += parseFloat(agesData[i].ageDueAmount.replace(/[$,]/g, ""));

    var ageUnpaidBill = JSON.parse(agesData[i].unpaidBill);

    for (let y = 0; y < ageUnpaidBill.length; y++) {
      let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },{"dest":"report",  "act":"jump", 
          "actJump":"goToSales", "dtId":"sale-dt", "toSearch":"${ageUnpaidBill[y].code}"  } ] }'`;

      table += `
        <tr ${rowStyle(i + y)}>
          <td ${css.td} >${ageUnpaidBill[y].date}</td>
          <td class='tdClick' ${css.td} ${detailHtml} >${ageUnpaidBill[y].code}</td>
          <td ${css.td} >${ageUnpaidBill[y].due_date}</td>
          <td ${css.td} >${ageUnpaidBill[y].original_amount}</td>
          <td ${css.td} >${ageUnpaidBill[y].due_amount}</td>
        </tr> 
      `;
    }
  }

  table += `
    <tr>
      <td ${css.td} colspan="4">
        <div align="right">
          <div style="font-weight: bold;">Total Due</div>
        </div>
      </td>
      <td ${css.td} >
        <div align="left">
          <div>${cashVal(totalDue)}</div>
        </div>
      </td>
    </tr> 
  `;

  table += `</table>`;

  return table;

  function cashVal(value) {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  function rowStyle(i) {
    if (i % 2 === 0) {
      return "";
    }
    return css.trGray;
  }
}